import React, { useState, useEffect, useRef } from 'react';
//import Select from 'react-select';
import axios from "axios";
import avatar from 'assets/img/default.jpg';
import ConnectedUnits from './ConnectedUnits'
import toast, { Toaster } from 'react-hot-toast';
import './Users.scss';

export default function UserDetails(props) {

    const emptyForm = {
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        company_id: '',
        country: '',
        status: '',
        super_user: '',
        units: ''
    }
    const [newDetails, setNewDetails] = useState(emptyForm)
    const [showUserDetails, setShowUserDetails] = useState(false)
    const [showConnectedUnits, setShowConnectedUnits] = useState(false)
    const noCompany = {'id':0, 'company_name': 'Not assigned'};
    const [companies, setCompanies] = useState([noCompany])
    const [connectedUnits, setConnectedUnits] = useState([])

    const API = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        withCredentials: true,
    });

    useEffect(() => {
        getCompanies();
        if(props.userId) {
            setShowUserDetails(true);
            getUserDetails(props.userId);
        } else {
            setShowUserDetails(false);
            console.log("user id missing")
        }
    }, [props.userId])

    useEffect(() => {
        document.addEventListener('mousedown',closeDetails)
        return () => {
            document.removeEventListener('mousedown',closeDetails);
        };
    }, [showConnectedUnits])

    async function getUserDetails(user_id) {
        try {
          const resUser = await API.post("/admin/users/details",{'id':user_id});
          setNewDetails(resUser?.data);
          const resUnits = await API.post("/units/connected",{'id':user_id});
          setConnectedUnits(resUnits.data)
        } catch (error) {
          console.log(error?.response?.data);
          toast.error(error?.response?.data);
        }
    }

    async function getCompanies() {
        try {
          const res = await API.post("/admin/companies");
          let companyList = res?.data;
          companyList.unshift(noCompany)
          setCompanies(companyList);
        } catch (error) {
          console.log(error?.response?.data);
          toast.error(error?.response?.data);
        }
    }

    const saveUserDetails = () => {
        API.post("/admin/users/update", newDetails )
        .then(response => {
          toast.success("User details saved")
          closeForm();
        })
        .catch(error => {
          console.log("error:", error.response.data)
          toast.error(error.response.data)
        });
    }

    const openUnitsTable = () => {
        setShowConnectedUnits(true)
    }

    const closeForm = () => {
        props.closeForm()
    }

    const closeDetails = (e) => {
        if(backdrop.current && !editForm.current.contains(e.target) && !showConnectedUnits){
            closeForm();
        }
    }

    const closeUnitsTable = () => {
        setShowConnectedUnits(false)
    }
    const saveUnitConnections = async () => {
        try {
            const resUnits = await API.post("/units/connected",{'id':props.userId});
            setConnectedUnits(resUnits.data)
        } catch (error) {
            console.log(error?.response?.data);
            toast.error(error?.response?.data);
        }
        closeUnitsTable()
    }

    const backdrop = useRef(null)
    const editForm = useRef(null)

    return (
    <div>
        <div id="edit" className={`modal fade ${ true? 'show' : ''}`} tabIndex="-1" role="dialog" style={{paddingRight: 5 + 'px'}} aria-modal="true">
            <div className="modal-dialog" role="document">
                <div ref={editForm} className="modal-content">
                    <div className="modal-header">
                        <button onClick={() => closeForm()} type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                        </button>
                        <h4 className="modal-title" data-locale="Edit User">Edit</h4>
                    </div>
                    <div className="modal-body">
                        <form className="form-horizontal">
                            <input type="hidden" name="_token" value="66vugfXt7TMAAU7MEvnGDk2Uj0SASvZrfme9pqEZ" />
                            <input type="hidden" name="id" value="1" />

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="First Name">First Name</label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control"  id="first_name" name="first_name" placeholder="First Name" readOnly={true} defaultValue={newDetails.first_name} />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Last Name">Last Name</label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" name="last_name" placeholder="Last Name" readOnly={true} defaultValue={newDetails.last_name} />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Email">Email</label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control"  id="email" name="email" placeholder="Email" readOnly={true} defaultValue={newDetails.email} />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Company Name">Company Name</label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" name="company" placeholder="Company Name" readOnly={true} defaultValue={newDetails.company} />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Company ID">Company ID</label>
                                <div className="col-sm-7">

                                    <select className="form-control" name="company_id" id="companyId" 
                                        onChange={(e) => setNewDetails({...newDetails, company_id: e.target.value})} value={newDetails.company_id}>
                                        {companies.map((company) => <option key={company.id} value={company.id}>{company.company_name}</option>)}
                                    </select>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Country Name">Country Name</label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" name="country" placeholder="Country Name" readOnly={true} defaultValue={newDetails.country} />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Status">Status</label>
                                <div className="col-sm-7">

                                    <select className="form-control" name="status"
                                        onChange={(e) => setNewDetails({...newDetails, status: e.target.value})} value={newDetails.status} >
                                        <option data-locale="enabled" value="1">Enabled</option>
                                        <option data-locale="disabled" value="0">Disabled</option>
                                    </select>

                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Admin">Admin</label>
                                <div className="col-sm-7">
                                    <select className="form-control" name="super_user"
                                        onChange={(e) => setNewDetails({...newDetails, super_user: e.target.value})} value={newDetails.super_user} >
                                        <option data-locale="yes" value="1">yes</option>
                                        <option data-locale="no" value="0">no</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label form-control-label" data-locale="Units">Units</label>
                                <div className="col-sm-7">
                                    <button onClick={() => openUnitsTable()} type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalTable" id="btnSelectUnit">
                                        Selected <span id="selectedUnitCount">{connectedUnits.length}</span> units
                                    </button>
                                </div>
                            </div>

                            <input type="hidden" name="unit_ids[]" id="unitIds" value="93" />

                            <div className="form-group row">
                                <div className="col-sm-10" style={{textAlign: 'right'}}>
                                    <button onClick={() => closeForm()} type="button" className="btn btn-default" data-dismiss="modal" data-locale="close">
                                        Close
                                    </button>
                                    <button onClick={() => saveUserDetails()} type="button" className="btn btn-primary save" data-locale="save">
                                        Save
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        { showConnectedUnits &&
            <ConnectedUnits closeForm={closeUnitsTable} saveChanges={saveUnitConnections} id={props.userId}/>
        }
        <div ref={backdrop} className={`fade modal-backdrop ${ showUserDetails ? 'show' : ''}`}></div>
    </div>
    )
    
}